export default "__VITE_ASSET__DRk_BEOZ__"